// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"b8aca6e0","675":"a3670f75","787":"a312b06a"}[chunkId] + ".chunk.js";
};